// extracted by mini-css-extract-plugin
export default {"wrapper":"MessageTime_wrapper__o7V3Y"};